import React from 'react'
import moment from 'moment'
import { DetailRow } from '../Cards/DetailsBox'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '600px',
  maxWidth: '90vw',
  bgcolor: 'background.paper',
  borderRadius: 1,
  boxShadow: 24,
  borderColor: 'none',
  maxHeight: 500,
  overflow: 'auto',
  padding: 1,
  outline: 'none',
}

const DrugAdminPopup = ({ viewLog }) => {
  return (
    <Stack gap={1} sx={{ ...style }}>
      <Typography variant="title3">Medicine Administration</Typography>
      <Typography variant="caption">
        This administration was recorded manually and is not associated with an
        ePCR.
      </Typography>
      <DetailRow label="Patient Name" value={viewLog?.patientName ?? ''} />
      <DetailRow
        label="Date of Birth"
        value={
          viewLog?.patientDOB
            ? moment(viewLog.patientDOB).format('Do MMM YYYY')
            : ''
        }
      />
      <DetailRow
        label="Administered By"
        value={
          (viewLog?.administeredBy?.firstName ?? '') +
          ' ' +
          (viewLog?.administeredBy?.lastName ?? '')
        }
      />
      <DetailRow
        label="Recorded By"
        value={
          (viewLog?.person?.firstName ?? '') +
          ' ' +
          (viewLog?.person?.lastName ?? '')
        }
      />
      <DetailRow label="Witnessed By" value={viewLog?.witnessedBy ?? ''} />
      <DetailRow
        label="Total Dose"
        value={viewLog?.totalDose ?? '' + viewLog?.totalDoseType ?? ''}
      />
      <DetailRow
        label="Time"
        value={moment(viewLog?.createdAt).format('Do MMM YYYY HH:mm')}
      />
      {viewLog?.affectedMeds && (
        <Stack gap={1} direction="row" flexWrap="wrap">
          {Object.keys(viewLog.affectedMeds).map((batch) => (
            <Box
              display="flex"
              borderRadius={1}
              key={batch}
              component={Paper}
              justifyContent="space-between"
              fontSize="0.75rem"
            >
              <Box
                bgcolor="#268EBB"
                color="#f2f2f2"
                borderRadius="3px 0px 0px 3px"
                padding={0.5}
                minWidth={20}
                display="flex"
                justifyContent="center"
                alignItems="center"
              >
                {viewLog.affectedMeds[batch].qty}
              </Box>
              <Box padding={1} className="medicine-box">
                BN: {viewLog.affectedMeds[batch].batchNumber ?? batch}. EXP:{' '}
                {moment(viewLog.affectedMeds[batch].expiry)
                  .format('DD/MM/YYYY')
                  .toString()}
              </Box>
            </Box>
          ))}
        </Stack>
      )}
    </Stack>
  )
}

export default DrugAdminPopup
